import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FullServiceRemovalSolutions() {
  return <section id="full-service-removal-solutions" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 flex items-center justify-center min-h-[80vh]">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] mix-blend-overlay z-0" style={{
      backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} aria-hidden="true" />

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none z-0" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-8 tracking-wide uppercase">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            Instant Quotes Available
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-8 text-balance">
            Full-Service <span className="text-primary drop-shadow-[0_0_15px_rgba(132,255,0,0.3)]">Removal</span> Solutions
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-12 leading-relaxed max-w-3xl text-balance">
            Looking to <strong className="text-foreground font-semibold">sell my junk car</strong>? Junk Car Pick Up BC offers top <strong className="text-foreground font-semibold">cash for cars Vancouver</strong> and surrounding areas. Our comprehensive <strong className="text-foreground font-semibold">scrap car pickup</strong> services ensure a hassle-free experience from start to finish. Whether you need unwanted vehicle removal or eco-friendly scrap car recycling, we provide free towing and instant quotes. Choose the most reliable <strong className="text-foreground font-semibold">junk car removal BC</strong> has to offer and turn your old vehicle into cash today.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-5 w-full sm:w-auto">
            <Button size="lg" asChild className="w-full sm:w-auto text-lg h-14 px-8 rounded-[5px] shadow-[0_0_20px_rgba(132,255,0,0.2)] hover:shadow-[0_0_30px_rgba(132,255,0,0.4)] transition-all duration-300">
              <Link to="tel:778-385-3007">
                <Phone className="mr-2 size-5" />
                Call 778-385-3007 Now
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" asChild className="w-full sm:w-auto text-lg h-14 px-8 rounded-[5px] border-primary/30 hover:bg-primary/10 hover:text-primary transition-colors duration-300">
              <Link to="/ServicesPage">
                Explore Services
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}